import { render } from "./MultichoiceActivity.vue?vue&type=template&id=68cde37d"
import script from "./MultichoiceActivity.vue?vue&type=script&lang=js"
export * from "./MultichoiceActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__